var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPinFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.59996 3.00063L14.4002 3.00063L14.3997 4.46751L13.6665 4.46751L13.6665 8.86659L15.1334 11.0666L15.1329 12.5335L10.7333 12.533L10.7333 17.6663L9.2669 17.6663L9.2669 12.533L4.8673 12.5335L4.86678 11.0667L6.33418 8.86607L6.33418 4.46699L5.601 4.46699L5.59996 3.00063Z",
    fill: "#CCCFD1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPinFill);
export default __webpack_public_path__ + "static/media/icon-pin-fill.21f172eafd78d9740d2cadf5ca52ace0.svg";
export { ForwardRef as ReactComponent };